<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>PMF详情</template>

  <template #body>
    <result-step
      v-if="condition"
      :condition="condition"
      :data-types="dataTypes"
      :audit-types="auditTypes"
      :sites="sites"
      :site-factor-map="siteFactorMap"
      :step-data="stepData"
      :is-run="false"
      :source-type="sourceType"
      style="height:100%;"
    />
  </template>
</drawer>
</template>

<script>
import Drawer from '../../../components/Layout/Drawer'
import ResultStep from './01PM/01Run/steps/03ResultStep'

export default {
  name: 'HistoryDetailView',
  components: {ResultStep, Drawer},
  props: {
    condition: {
      required: true
    },
    auditTypes: {
      required: true,
      type: Array
    },
    dataTypes: {
      required: true,
      type: Array
    },
    sites: {
      required: true,
      type: Array
    },
    siteFactorMap: {
      required: true,
      type: Object
    },
    stepData: {
      required: true
    },
    sourceType: {
      required: true,
      type: Number
    }
  },
  data: () => ({
    opened: false
  }),
  methods: {
    open () {
      this.opened = true
    },
    onCloseBtnClick () {
      this.opened = false
      this.$emit('closed')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/HistoryDetailView.vue